let _ = require('lodash');

const mainMenu = document.getElementById('block-main-menu');

if (! _.isNil(mainMenu)) {
    const subMenus = mainMenu.getElementsByClassName('menu-item--expanded');
    if (! _.isEmpty(subMenus)) {
        document.onclick = function (e) {
            if (!e.target.classList.contains('menu')
                && !e.target.classList.contains('menu-item--expanded-toggle')
                && !e.target.parentElement.classList.contains('menu')
                && !e.target.classList.contains('description')) {
                closeAllSubmenus();
            }
        }
    }

    // Submenu
    Array.from(subMenus).forEach(subMenu => {
        let subMenuButton = subMenu.querySelector('button');
        let parentParentSubmenu = subMenu.parentElement.parentElement;
        let parentSubmenu = subMenu.parentElement;

        subMenuButton.addEventListener('click', (e) => {
            if (subMenuButton.getAttribute('aria-expanded') !== 'true') {
                if (parentParentSubmenu.tagName != 'LI') {
                    closeAllSubmenus();
                }

                subMenu.classList.add('open');
                subMenuButton.setAttribute('aria-expanded', 'true');

                return;
            }

            subMenu.classList.remove('open');
            subMenuButton.setAttribute('aria-expanded', 'false');
        });
    });

    function closeAllSubmenus() {
        Array.from(subMenus).forEach(subMenu => {
            subMenu.querySelector('button').setAttribute('aria-expanded', 'false');

            subMenu.classList.remove('open');
        });
    }
}



// Menu toggle
const menuToggle = document.getElementById('menu-toggle');

if (! _.isNil(menuToggle)) {

    menuToggle.addEventListener('click', function () {
        if (menuToggle.getAttribute('aria-expanded') === 'true') {
            menuToggle.setAttribute('aria-expanded', 'false');
            document.body.classList.remove('main-menu-active');
        } else {
            menuToggle.setAttribute('aria-expanded', 'true');
            document.body.classList.add('main-menu-active');
        }
    });

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
            menuToggle.setAttribute('aria-expanded', 'false');
            document.body.classList.remove('main-menu-active');
        }
    });
}

// Footer navigation
const footerMenus = document.querySelectorAll('.region-footer .navigation');

if (!_.isEmpty(footerMenus)) {
    Array.from(footerMenus).forEach(menu => {
        menu.addEventListener('click', (e) => {
            menu.classList.toggle('open');
        });
    });
}


